const rankingData = [
  { rank: 1, title: '你比星光美丽', tag: '国产剧', hot: '热度 986万', update: '更新至36集', badge: '新' },
  { rank: 2, title: '眼泪女王', tag: '韩剧', hot: '热度 874万', update: '全16集', badge: '热' },
  { rank: 3, title: '与凤行', tag: '国产剧', hot: '热度 821万', update: '全39集', badge: '热' },
  { rank: 4, title: '背着善宰跑', tag: '韩剧', hot: '热度 756万', update: '全16集', badge: '荐' },
  { rank: 5, title: '玫瑰的故事', tag: '国产剧', hot: '热度 692万', update: '全38集', badge: '' },
  { rank: 6, title: '南来北往', tag: '国产剧', hot: '热度 638万', update: '全39集', badge: '' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 gap-4">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-800 mb-2">
              热播榜单
            </h2>
            <p className="text-foreground-500 text-sm">情侣们都在追的热门剧集，实时热度排行</p>
          </div>
          <div className="flex gap-2">
            <span className="whitespace-nowrap px-4 py-2 rounded-full bg-primary-500 text-white text-xs font-medium cursor-pointer">热播总榜</span>
            <span className="whitespace-nowrap px-4 py-2 rounded-full bg-background-50 text-foreground-500 text-xs border border-secondary-200 cursor-pointer hover:border-primary-300 transition-colors">国产剧榜</span>
            <span className="whitespace-nowrap px-4 py-2 rounded-full bg-background-50 text-foreground-500 text-xs border border-secondary-200 cursor-pointer hover:border-primary-300 transition-colors">韩剧榜</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {rankingData.map((item, idx) => (
            <a
              key={idx}
              href="#ranking"
              className="group flex items-center gap-4 bg-background-50 rounded-xl p-4 border border-secondary-100 hover:border-primary-200/60 transition-all"
            >
              <div className={`w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-xl font-heading text-lg font-bold ${
                idx < 3 ? 'bg-primary-500 text-white' : 'bg-secondary-100 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="font-heading text-base font-bold text-foreground-800 truncate group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  {item.badge && (
                    <span className={`flex-shrink-0 px-1.5 py-0.5 rounded text-[10px] font-medium ${
                      item.badge === '新' ? 'bg-accent-100 text-accent-700' :
                      item.badge === '热' ? 'bg-primary-100 text-primary-600' :
                      'bg-secondary-200 text-secondary-600'
                    }`}>{item.badge}</span>
                  )}
                </div>
                <div className="flex items-center gap-3 mt-1.5">
                  <span className="text-xs text-accent-600 bg-accent-50 px-2 py-0.5 rounded">{item.tag}</span>
                  <span className="text-xs text-foreground-400">{item.hot}</span>
                </div>
              </div>
              <span className="flex-shrink-0 text-xs text-foreground-400">{item.update}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}